
export default function Blog() {
  const blogPosts = [
    {
      category: 'レシピ',
      title: '春野菜を使った彩り豊かなサラダレシピ',
      excerpt: '旬の春野菜をたっぷり使った、見た目も美しく栄養満点のサラダをご紹介します。簡単に作れて、おもてなしにもぴったりです。',
      date: '2024年3月15日',
      image: 'https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/041d187686efe5a925243265f61a9d79.jpeg',
      author: '山田 花子',
      readTime: '5分'
    },
    {
      category: '料理のコツ',
      title: 'プロが教える包丁の研ぎ方と手入れ方法',
      excerpt: '料理の基本となる包丁のメンテナンス。正しい研ぎ方と日々のお手入れ方法を、プロの料理人が詳しく解説します。',
      date: '2024年3月12日',
      image: 'https://public.readdy.ai/ai/img_res/4fdb0472ba67d72bd3c09a4424f8ebb1.jpg',
      author: '佐藤 健太',
      readTime: '8分'
    },
    {
      category: 'イベント',
      title: '春の特別料理教室を開催します',
      excerpt: '4月に開催する春の特別料理教室のお知らせです。桜をテーマにした和菓子作りや、春の食材を使った本格フレンチコースをご用意しています。',
      date: '2024年3月10日',
      image: 'https://readdy.ai/api/search-image?query=Japanese%20cooking%20class%20event%20with%20students%20and%20instructor%20preparing%20spring%20themed%20dishes%20with%20cherry%20blossom%20decorations%20in%20bright%20modern%20kitchen%20studio%20with%20festive%20atmosphere%20and%20clean%20white%20background&width=600&height=400&seq=blog3&orientation=landscape',
      author: '田中 美咲',
      readTime: '4分'
    },
    {
      category: '食材の知識',
      title: '旬の魚介類の選び方と保存方法',
      excerpt: '新鮮な魚介類の見分け方から、家庭での正しい保存方法まで。魚料理をもっと美味しく楽しむための基礎知識をお届けします。',
      date: '2024年3月8日',
      image: 'https://readdy.ai/api/search-image?query=Fresh%20Japanese%20seafood%20and%20fish%20displayed%20on%20ice%20in%20modern%20market%20setting%20with%20bright%20natural%20lighting%20showing%20variety%20of%20seasonal%20catches%20in%20clean%20minimalist%20presentation%20with%20white%20background&width=600&height=400&seq=blog4&orientation=landscape',
      author: '鈴木 一郎',
      readTime: '6分'
    },
    {
      category: '生徒さんの声',
      title: '初心者から始めて半年、料理が楽しくなりました',
      excerpt: '全く料理経験がなかった生徒さんが、半年間のレッスンを通じて料理の楽しさに目覚めた体験談をご紹介します。',
      date: '2024年3月5日',
      image: 'https://readdy.ai/api/search-image?query=Happy%20Japanese%20woman%20student%20smiling%20while%20cooking%20in%20bright%20modern%20kitchen%20studio%20showing%20completed%20dish%20with%20pride%20and%20joy%20in%20clean%20white%20minimalist%20space%20with%20natural%20lighting&width=600&height=400&seq=blog5&orientation=landscape',
      author: '高橋 さくら',
      readTime: '7分'
    },
    {
      category: '健康レシピ',
      title: '栄養バランスを考えた一週間の献立',
      excerpt: '管理栄養士監修のもと、栄養バランスが整った一週間分の献立をご提案。忙しい方でも実践できる時短テクニックも紹介します。',
      date: '2024年3月3日',
      image: 'https://readdy.ai/api/search-image?query=Healthy%20balanced%20Japanese%20meal%20prep%20with%20variety%20of%20nutritious%20dishes%20in%20containers%20on%20wooden%20table%20in%20bright%20kitchen%20with%20fresh%20vegetables%20and%20ingredients%20in%20clean%20minimalist%20style%20with%20white%20background&width=600&height=400&seq=blog6&orientation=landscape',
      author: '中村 恵美',
      readTime: '10分'
    }
  ];

  return (
    <section id="blog" className="py-20 md:py-32 bg-white">
      <div className="w-full px-4 md:px-8 lg:px-16">
        <div className="max-w-[1000px] mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">ブログ</h2>
            <div className="w-20 h-1 bg-gradient-to-r from-pink-400 to-orange-400 mx-auto mb-6"></div>
            <p className="text-gray-600 max-w-2xl mx-auto">
              料理のコツやレシピ、教室の最新情報をお届けします
            </p>
          </div>

          <div className="grid grid-cols-1 gap-8">
            {blogPosts.map((post, index) => (
              <article key={index} className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all cursor-pointer group">
                <div className="h-48 overflow-hidden relative">
                  <img 
                    src={post.image}
                    alt={post.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  />
                  <span className="absolute top-4 left-4 bg-gradient-to-r from-pink-400 to-orange-400 text-white px-3 py-1 rounded-full text-sm font-medium">
                    {post.category}
                  </span>
                </div>
                <div className="p-6">
                  <div className="flex items-center text-sm text-gray-500 mb-3">
                    <i className="ri-calendar-line mr-2"></i>
                    <span>{post.date}</span>
                    <span className="mx-2">•</span>
                    <i className="ri-time-line mr-2"></i>
                    <span>{post.readTime}</span>
                  </div>
                  <h3 className="text-xl font-bold text-gray-800 mb-3 group-hover:text-pink-400 transition-colors">
                    {post.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed mb-4 line-clamp-3">
                    {post.excerpt}
                  </p>
                  <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                    <div className="flex items-center">
                      <div className="w-8 h-8 flex items-center justify-center bg-gradient-to-br from-pink-100 to-orange-100 rounded-full mr-2">
                        <i className="ri-user-line text-sm bg-gradient-to-r from-pink-400 to-orange-400 bg-clip-text text-transparent"></i>
                      </div>
                      <span className="text-sm text-gray-600">{post.author}</span>
                    </div>
                    <button className="text-pink-400 hover:text-orange-400 transition-colors whitespace-nowrap">
                      続きを読む <i className="ri-arrow-right-line ml-1"></i>
                    </button>
                  </div>
                </div>
              </article>
            ))}
          </div>

          <div className="text-center mt-12">
            <button className="bg-gradient-to-r from-pink-400 to-orange-400 text-white px-8 py-3 rounded-full hover:shadow-lg transition-all whitespace-nowrap cursor-pointer">
              ブログ一覧を見る
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
